import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Categories
export const getCategories = () => api.get('/categories');
export const getCategory = (slug) => api.get(`/categories/${slug}`);

// Tracks
export const getTracks = (category) => {
  const params = category ? { category } : {};
  return api.get('/tracks', { params });
};
export const getTrack = (trackId) => api.get(`/tracks/${trackId}`);
export const recordPlay = (trackId) => api.post(`/tracks/${trackId}/play`);

// Progress
export const getProgress = () => api.get('/progress');
export const updateStreak = () => api.post('/progress/streak');

// Favorites
export const toggleFavorite = (trackId) => api.post(`/favorites/${trackId}`);
export const removeFavorite = (trackId) => api.delete(`/favorites/${trackId}`);
export const getFavorites = () => api.get('/favorites');

// Feature Toggles
export const getFeatureToggles = () => api.get('/feature-toggles');

// Listening
export const recordListening = (trackId, seconds) => api.post('/listening/track', { track_id: trackId, seconds });
export const getListeningStats = () => api.get('/listening/stats');
export const getResumeTrack = () => api.get('/listening/resume');

// Mood
export const createMoodEntry = (data) => api.post('/mood', data);
export const getMoodEntries = (days = 7) => api.get('/mood', { params: { days } });
export const getTodayMood = () => api.get('/mood/today');

// Journal
export const createJournalEntry = (data) => api.post('/journal', data);
export const getJournalEntries = () => api.get('/journal');

// Affirmations
export const getDailyAffirmation = () => api.get('/affirmation/daily');
export const refreshAffirmation = () => api.post('/affirmation/refresh');
export const generateAffirmation = (category) => api.post('/affirmation/generate', null, { params: { category } });
export const generateAffirmationTTS = (text) => api.post('/affirmation/tts', null, { params: { text } });

// Recently Played
export const getRecentlyPlayed = () => api.get('/recently-played');

// Inner Shift 21-Day
export const getInnerShiftProgram = () => api.get('/inner-shift/program');
export const getInnerShiftProgress = () => api.get('/inner-shift/progress');
export const startInnerShiftChallenge = (length) => api.post('/inner-shift/start', { length });

// Billing / Stripe
export const createBillingCheckout = (plan, origin_url) => api.post('/billing/checkout', { plan, origin_url });
export const getBillingStatus = (sessionId) => api.get(`/billing/status/${sessionId}`);
export const getBillingMe = () => api.get('/billing/me');

export default api;
